export default __webpack_public_path__ + "static/media/tutorial5-1.538ef728.png";